<template>
  <div
    v-if="hasSlot('menu') && isMenuOpen && modal"
    class="-backdrop"
    @click="showHideMenu"
  >
    <!-- <Logo style="width: 100%; max-width: 384px; opacity: 0.2" /> -->
  </div>
  <div
    class="-button-anchor"
    v-bind="$attrs"
    :style="{
      position: sticky ? 'sticky' : '',
    }"
  >
    <button
      :class="`-button ${hidden && !isMenuOpen ? '-hidden' : ''}`"
      @click="showHideMenu"
    >
      <div v-if="hasSlot('icon') && isMenuOpen">
        <slot name="icon"></slot>
      </div>
      <div v-else>
        <NIcon size="40">
          <IconMenu />
        </NIcon>
      </div>
    </button>
    <div v-if="hasSlot('menu') && isMenuOpen" @click="showHideMenu">
      <slot name="menu" v-if="hasSlot('menu') && isMenuOpen"></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
.-backdrop {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-darkest);
  // backdrop-filter: blur(4px); // if semi-transparent
}
.-button-anchor {
  position: fixed;
  z-index: 1;
  display: block;
  width: fit-content;
}
.-button {
  position: relative; // for z-index

  padding: 0.5rem;
  color: var(--color-brand_light);

  --dur: var(--fx_duration);
  opacity: 1;
  z-index: 1;
  transition: opacity var(--dur) ease, z-index 0s linear var(--dur);
}
.-hidden {
  opacity: 0;
  z-index: -1;
  transition: opacity var(--dur) ease, z-index 0s linear 0s;
}
</style>

<script setup>
defineProps({
  sticky: { type: Boolean, default: false },
  hidden: { type: Boolean, default: false },
  modal: { type: Boolean, default: false },
});
import { NIcon } from "naive-ui";
import { ref, useSlots } from "vue";
import { IconMenu } from "./icons";
import Logo from "./Logo.vue";

const slots = useSlots();
const hasSlot = (name) => !!slots[name] && slots[name]().length > 0;

const isMenuOpen = ref(false);

function showHideMenu() {
  isMenuOpen.value = !isMenuOpen.value;
}
</script>
